import { useCallback } from 'react';
import { getFeed, hideAccount } from 'actions';
import { HIDE_SUCCESS } from 'actions/types';
import { fetchSpacesAction } from 'features/spaces/actions';
import useRefreshAccounts from 'hooks/useRefreshAccounts';
import { useAppDispatch } from 'store/hooks';
/**
 * Tracks or untracks credit report debts in net worth. A debt is tracked by
 * un-hiding the net worth account the backend imported it as.
 */
const useCreditReportDebtTracking = () => {
    const dispatch = useAppDispatch();
    const refreshAccounts = useRefreshAccounts();
    return useCallback(async (debts, isTracked) => {
        const body = debts.flatMap(({ networthAccountId }) => networthAccountId != null
            ? [{ id: networthAccountId, isHidden: !isTracked }]
            : []);
        if (!body.length)
            return false;
        const res = await dispatch(hideAccount(body));
        if (res?.type !== HIDE_SUCCESS)
            return false;
        refreshAccounts('MORTGAGE');
        dispatch(fetchSpacesAction());
        dispatch(getFeed());
        return true;
    }, [dispatch, refreshAccounts]);
};
export default useCreditReportDebtTracking;
